export default __webpack_public_path__ + "static/media/paystub-example-CAPS.9fb310e8.jpg";